import * as Sentry from '@sentry/react'
import { safeParseJson } from './safe-json'
import type { AuthUserResponse, ParseResponse } from './types'

export async function setUserState(
	parseResponse: ParseResponse<AuthUserResponse>,
	res: any,
	set,
) {
	const result = await safeParseJson(res, 'setUserState')
	if (!result.ok) return null

	let parsed: AuthUserResponse
	try {
		parsed = parseResponse(result.data)
	} catch (error) {
		Sentry.captureException(error, {
			tags: { context: 'setUserState.parseResponse' },
		})
		return null
	}

	const { user, ...restUser } = parsed

	const fullName = `${user.firstName} ${user.lastName}`

	Sentry.setUser({
		email: user.email,
		username: fullName,
		ip_address: '{{auto}}',
	})

	const newState = {
		loggedIn: true,
		tried: true,
		fullName,
		...restUser,
		...user,
		email: user.email,
		roles: restUser.permissions,
	} as const

	set((state) => {
		state.user = newState
	})

	return newState
}
